const DAYS: Record<string, number> = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6
};

export type StoreStatus = {
  isOpen: boolean;
  isPaused: boolean;
  label: string;
};

const formatTime = (time: string) => (time || '').substring(0, 5);

export const getStoreStatus = (store: any, now = new Date()): StoreStatus => {
  if (store?.deliveryFechado === true || store?.bloquearAcesso === true) {
    return { isOpen: false, isPaused: true, label: 'Pedidos pausados' };
  }

  const dayName = Object.keys(DAYS).find((day) => DAYS[day] === now.getDay());
  const schedules = (Array.isArray(store?.horarios) ? store.horarios : [])
    .filter((schedule: any) => schedule?.dayOfWeek === dayName && schedule?.start)
    .sort((a: any, b: any) => a.start.localeCompare(b.start));

  for (const schedule of schedules) {
    const [hour, minute] = String(schedule.start).split(':').map(Number);
    const start = new Date(now);
    start.setHours(hour, minute, 0, 0);
    const end = new Date(start.getTime() + Number(schedule.duration || 0) * 60000);

    if (now >= start && now <= end) {
      return { isOpen: true, isPaused: false, label: `Aberta até ${formatTime(end.toTimeString())}` };
    }
    if (now < start) {
      return { isOpen: false, isPaused: false, label: `Abre às ${formatTime(schedule.start)}` };
    }
  }

  return { isOpen: false, isPaused: false, label: 'Fechada' };
};
